<template>
    <section class="vx-row justify-center w-full py-6 md:py-12 lg:py-24 mb-24 mx-1">
        <div class="vx-col w-full md:w-5/6">
            <vx-card>
                <payment-option-container
                    :transactionProduct="transactionProduct"
                    @pay="pay"
                >
                <!-- header -->
                <template v-slot:header>
                    <div class="flex mb-8">
                    <router-link :to="`/qurban/checkout/${$route.params.slug_and_id}`">
                        <feather-icon icon="ChevronLeftIcon" svgClasses="text-primary mr-4"></feather-icon>
                    </router-link>
                    <strong class="text-primary"><small>Pilih Metode dPembayaran</small></strong>
                    </div>
                </template>
                <!-- / -->

                <!-- Content -->
                <template v-slot:content="{ paymentGateways }">
                    <div class="mb-8 vx-row mx-0 w-full justify-center items-center">
                    <div class="vx-col w-full md:w-1/2 mb-3 md:mb-0">
                        <vs-button type="filled" class="w-full" size="large" @click.prevent="showPaymentGateway('va')">
                        <small>Virtual Account</small>
                        </vs-button>
                    </div>
                    <div class="vx-col w-full md:w-1/2">
                        <vs-button type="border" class="w-full" size="large" @click.prevent="showPaymentGateway('other')">
                        <small>Lainnya</small>
                        </vs-button>
                    </div>
                    </div>
                    <div 
                        class="vx-col w-full rounded-lg mb-6"
                        v-for="(item, i) in paymentGateways"
                        :key="i"
                        style="border: 1px solid #ccc;"
                    >
                        <div class="vx-row py-4 px-4 items-center cursor-pointer" @click.prevent="selectedPayment = item.id">
                            <div class="vx-col w-1/4 md:w-1/6">
                                <img v-if="item.file === null" :src="`/assets/images/payment_method/${item.code}.png`" alt="" class="w-12 md:w-16 block text-left" />
                                <img v-else :src="item.file" alt="" class="w-12 md:w-16 block text-left" />
                            </div>
                            <div class="vx-col w-1/2 md:w-2/3">
                                <h5 class="text-left text-sm md:text-md lg:text-lg" @click.prevent="selectedPayment = item.id">
                                    <strong>{{item.name}}</strong>
                                </h5>
                                <small v-if="item.code === 'saldo' && notEnoughBalance" class="mt-2">
                                    Saldo anda tidak mencukupi
                                </small>
                            </div>
                            <div class="vx-col w-1/4 md:w-1/6 text-right">
                                <div v-if="item.code === 'saldo'">
                                    <vs-button
                                    v-if="notEnoughBalance"
                                    type="border"
                                    class="rounded-none p-2"
                                    color="primary"
                                    size="small"
                                    @click.prevent="$router.push('/balance/checkout')"
                                    >
                                    Isi Saldo
                                    </vs-button>
                                    <div class="mx-auto" v-else>
                                        <input type="radio" :value="item.id" v-model="selectedPayment" class="rad" />
                                    </div>
                                </div>
                                <div class="mx-auto" v-else>
                                    <input type="radio" :value="item.id" v-model="selectedPayment" class="rad" />
                                </div>
                                <!-- <vs-radio v-else :vs-value="item.id" v-model="selectedPayment"></vs-radio> -->
                            </div>
                        </div>
                    </div>
                </template>          
                <!-- / -->

                <!-- description -->
                <template #description>
                    <table class="w-full px-4 mb-8">
						<tr class="mb-4" style="vertical-align: top;">
							<td class="text-left">
								<strong class="text-grey">Lembaga Penyaluran</strong>
							</td>
							<td class="text-right">
								<strong>{{ transactionProduct.mt ? (transactionProduct.mt.user ? transactionProduct.mt.user.name : '-') : '-' }}</strong>
							</td>
						</tr>

                        <tr class="mb-4" style="vertical-align: top;">
							<td class="text-left">
								<strong class="text-grey">Qurban</strong>
							</td>
							<td class="text-right">
								<strong>{{ transactionProduct ? transactionProduct.name : '-' }}</strong>
							</td>
						</tr>

                        <tr class="mb-4" style="vertical-align: top;"></tr><tr class="mb-4">
							<td class="text-left">
								<strong class="text-grey">Jumlah Mudhohi</strong>
							</td>
							<td class="text-right">
								<strong>{{ transactionProduct.mudhohis.length }} orang</strong>
							</td>
						</tr>

                        <tr class="mb-4" style="vertical-align: top;">
							<td class="text-left">
								<strong class="text-grey">Total Bayar</strong>
							</td>
							<td class="text-right">
								<strong>Rp {{ transactionProduct.price == 0 ? 0 : formatRupiah(transactionProduct.price) }}</strong>
							</td>
						</tr>
                    </table>
                </template>
                <!-- / -->
                </payment-option-container>
            </vx-card>
        </div>
    </section>
</template>
<script>
    import {mapState} from 'vuex'
    export default {
        components: {
            PaymentOptionContainer: () => import('@/views/components/transaction/CheckoutPaymentOption.vue')
        },
        data: () => ({
            paymentGateways: []
        }),
        computed: {
            transactionProduct() {
                let transactionProduct = {};
                Object.assign(transactionProduct, this.$store.state.qurban.transactionProduct);
                return transactionProduct;
            },
            ...mapState('payment-gateway', ['va_payment_gateway', 'other_payment_gateway', 'payment_gateway']),
            selectedPayment: {
                get() {
                    return this.$store.state['payment-gateway'].selectedPayment;
                },
                set(val) {
                    this.$store.dispatch('payment-gateway/setSelectedPayment', val);
                }
            }
        },
        methods: {
            showPaymentGateway (typePayment) {
                if (typePayment === 'va') {
                    const pg = this.va_payment_gateway.slice();
                    this.$store.dispatch(`payment-gateway/changePaymentGateway`, pg);
                } else {
                    const pg = this.other_payment_gateway.slice();
                    this.$store.dispatch(`payment-gateway/changePaymentGateway`, pg);
                }
            },
            pay(payment) {
                // Set selected payment method
                const pays = this.payment_gateway.find(it => it.id == this.selectedPayment);
                if (!pays) {
                    this.$vs.notify({
                        title: 'Metode Pembayaran Tidak ditemukan',
                        text: 'coba beberapa saat lagi',
                        color: 'warning',
                        position: 'top-right'
                    });

                    return false;
                }
                this.$store.dispatch(`qurban/setTransactionPayment`, pays);
                
                let link = `/qurban/confirm/${this.$route.params.slug_and_id}`;

                if(this.$route.query.ref) {
                    link += `?ref=${this.$route.query.ref}`;
                }

                this.$router.push(link);
            }
        },
        created() {
            this.checkVerifyAccount();

            if( !this.transactionProduct || Object.keys( this.transactionProduct ).length < 1 ) {
                this.$router.push('/home');
            }
        }
    }
</script>
<style>
    .rad {
        position: relative;
        -webkit-appearance: none;
        appearance: none;
        background-color: #fff;
        font: inherit;
        width: 1rem;
        height: 1rem;
        border: 2px solid #FFCB05;
        border-radius: 50%;
    }
    .rad::before {
        content: '';
        border-radius: 50%;
        transform: scale(0);
        transition: 120ms transform ease-in-out;
        box-shadow: inset 1em 1em #045532;
        background: #045532;
    }
    .rad::after {
        content: '';
        opacity: 0;
        display: block;
        border-radius: 50%;
        width: 100%;
        height: 100%;
        position: absolute;
        background: #045532;
    }
    .rad:checked {
        border: 2px solid #045532;
        transition: .1s ease-in;
        transform: scale(1.3);
    }
    .rad:checked::after {
        opacity: 1;
    }
</style>